import {createEntityAdapter, createSlice, EntityState,} from "@reduxjs/toolkit";
import {Region} from "../../../model/region";
import {changeRegion} from "./actions";
import {regionApi} from "./region-store";

export const regionsAdapter = createEntityAdapter({
  selectId: (r: Region) => r.id,
  sortComparer: (a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
});

export type RegionState = EntityState<Region, string> & {
  currentRegionId: string | undefined;
};

const regionSlice = createSlice({
  name: 'regions',
  initialState: regionsAdapter.getInitialState<RegionState>({
    currentRegionId: undefined,
    entities: {},
    ids: [],
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(changeRegion, (state, {payload}) => {
      state.currentRegionId = payload;
    });
    builder.addMatcher(regionApi.endpoints.getAllRegions.matchFulfilled, (state, {payload}) => {
      regionsAdapter.setAll(state, payload);
    })
    builder.addMatcher(regionApi.endpoints.getAccessibleRegions.matchFulfilled, (state, {payload}) => {
      regionsAdapter.upsertMany(state, payload);
    })
    builder.addMatcher(regionApi.endpoints.getRegion.matchFulfilled, (state, {payload}) => {
      regionsAdapter.upsertOne(state, payload);
    })
  },
});

export const regionReducer = regionSlice.reducer;
